<template>
  <div
    v-if="isNBYXSupplier && !isLoading"
    v-loading="isLoading"
    element-loading-text="加载中"
    style="margin-bottom: 12px; min-width: var(--table-width)"
  >
    <el-tabs
      v-model="originType"
      @tab-click="tabsClick"
    >
      <el-tab-pane
        label="网上农博"
        name="1"
        :disabled="disabled"
      />
      <el-tab-pane
        label="中国土特产"
        name="3"
        :disabled="disabled"
      />
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'nbyx-tabs',
  data() {
    this.defaultStoreId = localStorage.getItem('defaultStoreId');

    return {
      isLoading: true,
      isNBYXSupplier: false,
      originType: '1', // 1/null：农博，3：土特产
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.checkIsNBYXSupplier();
  },
  methods: {
    tabsClick(tab) {
      const originType = this.originType === '3' ? this.originType : null;
      this.$emit('changeOriginType', originType);
    },
    async checkIsNBYXSupplier() {
      this.isLoading = true;
      const params = { storeId: this.defaultStoreId };
      try {
        const res = await this.$axios.get(
          this.$api.supplychain.checkIsNBYXSupplier,
          {
            params,
          },
        );
        if (res.code === 0) this.isNBYXSupplier = res.data.isNBYXSupplier;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
